export function buildRevenueAccountsByStrategyIdQueryV1(workspaceId: number, strategyId: string)
{
    return {
        '$type': 'TCh.Domain.Quest.Financials.Revenues.Queries.RevenueAccountsByStrategyIdQueryV1, TCh.Domain.Quest',
        'WorkspaceId': workspaceId,
        'StrategyId': strategyId,
    }
}

export function buildRevenueAccountByIdQueryV1(workspaceId: number, strategyId: string, revenueId: string)
{
    return {
        '$type': 'TCh.Domain.Quest.Financials.Revenues.Queries.RevenueAccountByIdQueryV1, TCh.Domain.Quest',
        'WorkspaceId': workspaceId,
        'StrategyId': strategyId,
        'RevenueId': revenueId,
    }
}
